import { useState } from "react";
import StorageCard from "../../../components/StorageCard";
import DetailStorage from "../../../components/StorageCard/detailStorage";

const Storage: React.FC = () => {
    const [imagesLoading, setImagesLoading] = useState(false);

    return (
    <div className="my-3 my-md-5">
        <div className="container">
            <div className="page-header">
                <h1 className="page-title">Gerenciamento de espaço</h1>
            </div>
        </div>
        <div className="container px-5">
            <div className="row">
                <div className="card">
                    <div className="card-header p-5">Espaço de Armazenamento</div>
                    <div className="card-body">
                        <div className={'dimmer' + (imagesLoading ? ' active' : '')}>
                            <div className="loader"></div>
                            <div className={'dimmer-content' + (imagesLoading ? ' medium-box-loader' : '')}>
                                <StorageCard />
                                <DetailStorage />
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>                
);
}

export default Storage;
